module.exports = "/_next/static/images/ImplementationOptions@2x-89d0c355ed59ac6e76dada544f97f31b.png";